// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"3b10fb93","366":"be7a9db2","392":"98187493","808":"4ce3ead5"}[chunkId] + ".chunk.css";
};